import ListIqamaRenewList from "./ListIqamaRenewList";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIqamaData } from "./../../../../../store/Api";
import FileUploadElement from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import { set } from "react-hook-form";
import nodeinstance from "../../../../../nodeInstance";

export default function IqamaPhysicalCard({ setData }) {
  const IqamaData = useSelector((state) => state.iqamaData);

  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getIqamaData(token));
  }, []);



  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
  });

  const [filterData, setFilterData] = useState();

  // const [trigger,setTrigger] = useState(false)

  const Nodetoken = localStorage.getItem("nodeToken");
  const API = async () => {
    const response = await nodeinstance.get(`/iqama/GetFilterEmployees`, {
      headers: {
        Authorization: `Bearer ${Nodetoken}`,
      },
    });
    if (response) {
      console.log("response.......", response);
      setFilterData(response.data.data);
    }
  };

  useEffect(() => {
    API();
  }, []);

  const updateData = () => {
    dispatch(getIqamaData(token));
    API()
  };

  return (
    <>
      {showPromptElement.open && (
        <FileUploadElement
          title={"Upload Tamplate with Border Number"}
          subTitle={"Upload templete"}
          showFileUploadElement={showPromptElement}
          setShowFileUploadElement={setShowPromptElement}
        />
      )}
      <ListIqamaRenewList
        titles={[
          "S.NO.",
          "EMPLOYEE ID",
          "ACTUAL PROFESSION",
          "nationality",
          "VISA PROVIDER",
          "SPONSOR ID",
          "CLIENT NAME",
          "IQAMA NUMBER",
          "IQAMA RECEIVED DATE",
          "IQAMA ISSUE DATE",
          "IQAMA EXPIRY DATE (G)",
          "IQAMA EXPIRY DATE (H)",
          "AGING DAYS",
          "VALID DAYS",
          // "COMMENTS",
          "tenure",
          "status",
          "Action",
        ]}
        list={filterData}
        loading={loading}
        token={token}
        updateData={updateData}
        uploadFile={setShowPromptElement}
        callBack={updateData}
        setLen={setData}
      />
    </>
  );
}
